// extracted by mini-css-extract-plugin
export var progressBar = "_kr-0";
export var progressBarInner = "_kr-1";